import { ModelMixin } from '../core/base-generic.model';
import { Employee } from '../employee/employee.model';

export class ApplicantMessageTemplate extends ModelMixin<ApplicantMessageTemplate>() {
    protected static _resource = 'applicantTracker/applicant-message-templates';
    protected static _version = 'v2';
    protected static _serializeAttributes = ['name', 'body', 'subject'];
    protected static _datetimes = ['createdAt'];

    get createdAt(): Date {
        return this._attributes['createdAt'];
    }

    get createdBy(): number {
        return this._attributes['createdBy'];
    }

    get creator(): Employee {
        return this.hasOne(Employee, 'creator');
    }

    get id(): number {
        return this._attributes['id'] || null;
    }

    get name(): string {
        return this._attributes['name'];
    }

    set name(value: string) {
        this._attributes['name'] = value;
    }

    get body(): string {
        return this._attributes['body'];
    }

    set body(value: string) {
        this._attributes['body'] = value;
    }

    get subject(): string {
        return this._attributes['subject'];
    }

    set subject(value: string) {
        this._attributes['subject'] = value;
    }
}
